var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingFlag,
          expression: "loadingFlag",
        },
      ],
      staticClass: "out-box",
    },
    [
      _c(
        "div",
        { staticClass: "inner-box" },
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              attrs: {
                drag: "",
                action: _vm.actionUrl,
                data: _vm.actionQuery,
                "on-success": _vm.uploadImgSuccess,
                "show-file-list": false,
                "on-change": _vm.fileChange,
                "before-upload": _vm.beforeAvatarUpload,
                limit: 1,
                accept: ".jpg,.jpeg,.png,",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "el-upload__text",
                  staticStyle: {
                    margin: "60px 0 0 0",
                    color: "rgba(0, 0, 0, 0.4)",
                  },
                },
                [
                  _c("p", [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                  _c("p", [_vm._v("只能上传jpg/png文件，且不超过7M")]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c("label", { class: _vm.formatClassByType(_vm.backgroundType) }, [
        _vm.picShow
          ? _c("img", { attrs: { src: _vm.imgShow, alt: "" } })
          : _vm._e(),
      ]),
      _vm.showFileName
        ? _c("p", { staticClass: "doc_name_wrapper" }, [
            _vm.picShow
              ? _c("em", {
                  staticClass: "el-icon-view",
                  on: { click: _vm.openImgPreview },
                })
              : _vm._e(),
            _c(
              "span",
              {
                staticClass: "doc_name",
                on: {
                  click: function ($event) {
                    return _vm.openImgPreview()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.docNameCopy))]
            ),
            _c("span", { staticClass: "deleteIcon" }, [
              _c("em", {
                staticClass: "el-icon-close",
                on: {
                  click: function ($event) {
                    return _vm.delMent()
                  },
                },
              }),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "imgDialogView",
          attrs: {
            title: _vm.backgroundTypeTransformation(_vm.backgroundType),
            visible: _vm.centerDialogVisible,
            width: "50%",
            "show-close": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
              },
            },
            [
              _vm.picShow
                ? _c("img", {
                    ref: "rotateImg",
                    staticStyle: { width: "90%" },
                    attrs: { src: _vm.imgShow, alt: "" },
                  })
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.rotate(0)
                    },
                  },
                },
                [_vm._v("左旋转")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.rotate(1)
                    },
                  },
                },
                [_vm._v("右旋转")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }